import React, { useRef } from 'react';
import classes from './MediaItem.module.scss';
import { MediaType } from '../../../models/graphql';
import { Icon } from '../../../components/images/Icon/Icon';
import { IconsEnum } from '../../../constants/icons';
import { Loader } from '../../../components/containers/Loader';
import classNames from 'classnames';
import { CSSTransition } from 'react-transition-group';
import { WhatInputType } from 'what-input';
import { Debugger } from '../../../components/containers/Debugger';

type BaseMediaItemViewProps = {
  loading?: boolean;
  publishNext: boolean;
  type: MediaType;
  onClose: VoidFunction;
  intentType: WhatInputType;
  droppable: boolean;
};
export type MediaItemViewProps = BaseMediaItemViewProps &
  ({ image?: string; id?: string } | { image?: never; id?: never });

export const MediaItemView = (props: MediaItemViewProps): JSX.Element => {
  const { image, id, type, publishNext, loading, onClose, intentType, droppable } = props;
  const loaderNodeRef = useRef<HTMLDivElement>(null);
  const mainClasses = classNames(classes.MediaItem, {
    [classes.MediaItemLoading]: loading,
    [classes.MediaItemDroppable]: droppable
  });
  const closeWrapperClasses = classNames(
    classes.CloseWrapper,
    intentType === 'touch' ? classes.CloseWrapperTouch : classes.CloseWrapperMouse
  );

  return (
    <>
      <Debugger tooltipContent={'Media ID: ' + props.id} modalContent={props} />
      <div className={mainClasses}>
        <div className={classes.ImageWrapper}>{image ? <img src={image} alt={`preview-${id}`} /> : null}</div>
        <div className={closeWrapperClasses}>
          <a className={classes.CloseButton} onClick={() => onClose()}>
            <span className={classes.CloseButtonCircle}>
              <span className={'show-for-sr'}>&times;</span>
            </span>
          </a>
        </div>
        {type === MediaType.VIDEO ? (
          <div className={classes.Video}>
            <Icon name={IconsEnum.video} size={'medium'} />
          </div>
        ) : null}
        {publishNext ? <div className={classes.PublishNext}>Publish Next</div> : null}
        <CSSTransition in={!!loading} timeout={300} classNames={'fade'} nodeRef={loaderNodeRef} unmountOnExit>
          <div className={classes.LoadingWrapper} ref={loaderNodeRef}>
            <Loader variation={'dark'} size={'large'} />
          </div>
        </CSSTransition>
      </div>
    </>
  );
};
